import LocationsList from './LocationsList';
export default LocationsList;